import React, { memo } from 'react';
import PropTypes from 'prop-types';

const DEFAULT_TEXT = 'No items found';
const NoItemsFound = memo(({ text, columnsLength }) => (
  <tr>
    <td colSpan={columnsLength} className="text-center">
      {text}
    </td>
  </tr>
));

NoItemsFound.propTypes = {
  columnsLength: PropTypes.number.isRequired,
  text: PropTypes.string,
};

NoItemsFound.defaultProps = {
  text: DEFAULT_TEXT,
};

export default NoItemsFound;
